import { getAuth } from "firebase/auth";

export function detectPlatformForFcm() {
  const ua = (navigator.userAgent || "").toLowerCase();

  if (ua.includes("firefox")) {
    return "web-firefox";
  }

  const isSafari = ua.includes("safari") && !ua.includes("chrome") && !ua.includes("chromium") && !ua.includes("edg") && !ua.includes("opr");
  if (isSafari) {
    return "web-safari";
  }

  return "web-chrome";
}

export const sendNotificationTest = async (userId) => {
  const auth = getAuth();
  const user = auth.currentUser;
  if (!user) throw new Error("Non authentifié");
  const token = await user.getIdToken();

  const params = {};
  if (userId) params.userId = userId;

  const response = await fetch("/notificationTestHttp", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
    body: JSON.stringify(params),
  });

  if (!response.ok) {
    const error = await response.text();
    throw new Error(error);
  }
  return await response.json();
};
